import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, FormControl, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, FormGroup } from '@angular/forms';
import { Location } from '@angular/common'
import { interval, Subscription, Observable, of } from 'rxjs';
import { take, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { ReportsService } from '../../services/reports.service';
import { PaymentsService } from '../../services/payments.service';
import { OrdersService } from '../../services/orders.service';
import { PrintService } from '../../services/print.service'
import { UsersService } from '../../services/users.service'
import { ConfigService } from '../../services/config.service';
import * as FileSaver from 'file-saver';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';



@Component({
	selector: 'app-daily-transactions',
	templateUrl: './daily-transactions.component.html',
	styleUrls: ['./daily-transactions.component.scss']
})
export class DailyTransactionsComponent implements OnInit {

	@ViewChild('print_table') printtable: ElementRef;

	@ViewChild('voidDetails') voidDetailsRef: ElementRef;

	private sort: MatSort;

	@ViewChild(MatSort) set matSort(ms: MatSort) {
		this.sort = ms;
		this.setDataSourceAttributes();
	}

	@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {

		this.paginator = mp;
		this.setDataSourceAttributes();
	}

	setDataSourceAttributes() {
		this.dataSource.paginator = this.paginator;
	}

	color = 'blue';
	payments: any = [];
	salespeople: any = [];
	today = new Date();
	filename = 'dailytransactions';
	title = 'Daily Transactions';
	@ViewChild('details') detailsRef: ElementRef;
	datefrom = new UntypedFormControl(this.today);
	dateto = new UntypedFormControl(this.today);
	create_credit = new UntypedFormControl(true);
	empcode = new FormControl('');
	running = false;
	hideextrafields = false;
	total_pay: any = '';
	journals: any = false;
	displaydetails: any = false;
	total_trans: any = 0;
	total_sub: any = 0;
	total_tax: any = 0;
	total_freight: any = 0;
	total_fee: any = 0;
	total_discount: any = 0;
	locations: any = [];
	user: any = false;
	defaultlocation = new UntypedFormControl('');
	salesperson = new UntypedFormControl('');
	searcher = new UntypedFormControl('');
	ref_location: any = false;
	exporting = false;
	config: any = false;


	dataSource: MatTableDataSource < any > ;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	dataObs: Observable < any > ;
	items_per_page = [25, 50, 100, 200, 500];
	pagesizedefault = 200;
	voiddate = new UntypedFormControl(new Date());
	void_trans: any = false;
	voiding = false;
	isPosUser = false;
	emperror = false;
	searchresults: any = false;

	cctotal = 0;
	payment_methods: any = false;
	fetchingJournals: any = false;

	constructor(private ordersService: OrdersService, private usersService: UsersService, private _changeDetectorRef: ChangeDetectorRef, private location: Location, private reportsService: ReportsService, private printService: PrintService, private globalSearchService: GlobalSearchService, private globalsService: GlobalsService, private paymentsService: PaymentsService, private fb: UntypedFormBuilder, private route: ActivatedRoute, public router: Router, private modalService: NgbModal, private http: HttpClient, private configService: ConfigService) {

		this.globalSearchService.configsubscription.subscribe(s => {
			this.config = s;
			this.applyDailyTransactionsExtraFieldsVisibility();
		})

		this.color = this.globalSearchService.getColor();

		this.globalSearchService.payment_methods.subscribe(r => {
			this.payment_methods = r;
		});

		this.globalSearchService.user.subscribe(results => {
			//only run if user is definied

			if (this.user) {
				if (results.user.defaultlocation.loccode !== this.ref_location) {
					this.defaultlocation.setValue([this.user.user.defaultlocation.loccode]);
					this.ref_location = false;
				}
			}

			this.user = results

			if (!this.ref_location) {
				this.ref_location = this.user.user.defaultlocation.loccode;
			}
		});

		this.usersService.isPosUser().subscribe((isPOS) => {
			if (isPOS) {
				this.isPosUser = true;
			}
			this.globalsService.getLocations().subscribe(async (results: any) => {
				if (results) {
					// Assuming isPosUser is a boolean indicating whether the user is a POS user

					if (this.isPosUser || (this.user.user.issalesman && this.config?.env?.client !== 'summit')) {
						// Filter locations to only include the user's default location
						this.locations = results.filter(location =>
							location.loccode === this.user.user.defaultlocation.loccode
						);

						const val = [
							this.user.user.defaultlocation.loccode
						];
						this.defaultlocation.setValue(val);
					} else {
						// If the user is not a POS user or a salesman, use all locations
						this.locations = results;
					}

					this.loadData();
				}
			});
		})


		this.reportsService.getSalesPeople().subscribe((results: any) => {
			this.salespeople = results;
		});

		this.searcher.valueChanges.subscribe(newValue => {
			this.filterSearch();
		});
	}

	filterSearch() {

		if (this.searcher.value == '') {
			this.searchresults = this.payments.transactions;
			this.setPagination(this.searchresults);
		} else {
			this.searchresults = this.globalSearchService.filterItem(this.payments.transactions, this.searcher.value, 'orderno,order_,transno,debtorno,trandate,name')
			this.setPagination(this.searchresults);
		}
	}


	ngOnInit(): void {
		this.setPagination([]);
	}

	private coerceConfigBool(v: unknown): boolean {
		return v === true || v === 'true' || v === 1 || v === '1';
	}

	private dailyTransactionsShowExtraFieldsEnabled(cfg: any): boolean {
		if (!cfg) {
			return false;
		}
		return (
			this.coerceConfigBool(cfg.dailyTransactionsShowExtraFields) ||
			this.coerceConfigBool(cfg.features?.dailyTransactionsShowExtraFields)
		);
	}

	private applyDailyTransactionsExtraFieldsVisibility(): void {
		const cfg = this.config;
		if (!cfg?.env) {
			return;
		}
		if (cfg.env.package !== 'beauty') {
			this.hideextrafields = false;
			return;
		}
		const show = this.dailyTransactionsShowExtraFieldsEnabled(cfg);
		this.hideextrafields = !show;
		if (!show) {
			this.syncDailyTransactionsExtraFieldsFromCanonicalFile();
		}
	}

	/**
	 * Stale v8ConfigOverride in localStorage often omits keys added after the snapshot was saved.
	 * Read the on-disk config for the active setup key so flags like dailyTransactionsShowExtraFields apply.
	 */
	private syncDailyTransactionsExtraFieldsFromCanonicalFile(): void {
		const key = this.configService.getCurrentConfig();
		const url = `assets/config/config.${key}.json?t=${Date.now()}`;
		this.http
			.get<any>(url)
			.pipe(
				take(1),
				catchError(() => of(null))
			)
			.subscribe((fresh) => {
				if (!fresh || !this.dailyTransactionsShowExtraFieldsEnabled(fresh)) {
					return;
				}
				if (this.config?.env?.package !== 'beauty') {
					return;
				}
				this.hideextrafields = false;
				this._changeDetectorRef.markForCheck();
			});
	}

	loadData() {
		this.running = true;
		const data = { from: this.datefrom.value, to: this.dateto.value, locations: this.defaultlocation.value, salesperson: this.salesperson.value }
		this.paymentsService.getDailyTransactions(data).subscribe((results: any) => {
			this.running = false;
			this.payments = results;

			if (results.transactions.length) {
				this.items_per_page = [25, 50, 100, 500, results.transactions.length];
			}

			this.setPagination(results.transactions);

			// Utility function to calculate the total
			const calculateTotal = (transactions: any[], key: string) =>
				transactions.reduce((accumulator: number, item: any) => accumulator + parseFloat(item[key]), 0);

			// Assign totals using the utility function
			this.total_trans = calculateTotal(results.transactions, 'total');
			this.total_sub = calculateTotal(results.transactions, 'ovamount');
			this.total_tax = calculateTotal(results.transactions, 'ovgst');
			this.total_freight = calculateTotal(results.transactions, 'ovfreight');
			this.total_fee = calculateTotal(results.transactions, 'ovfee');
			this.total_discount = calculateTotal(results.transactions, 'ovdiscount');

			// Calculate cctotal
			this.cctotal = results.summary.reduce((accumulator: number, item: any) => {
				const ttype = this.payment_methods.find((t: any) => t.paymentname === item.type);
				const value = (ttype && ttype.cc_process === '1') ? parseFloat(item.amount) : 0;
				return accumulator + value;
			}, 0);

			// Calculate total_pay
			this.total_pay = results.summary.reduce((accumulator: number, item: any) => accumulator + parseFloat(item.amount), 0);

			//this.getJournals();
		})
	}

	getLocationNamesFormatted(): string {
		if (!this.defaultlocation.value.length && (this.isPosUser || this.user.user.issalesman)) {return 'N/A';}

		const loclist = this.defaultlocation.value.length ? this.defaultlocation.value : this.locations.map((l) => {return l.loccode});
		
		return loclist.map(v => {
			const loc = this.locations.find(r => v === r.loccode);
			return loc ? loc.locationname : '';
		}).filter(Boolean).join(', ');
	}


	getLocationName() {
		let name = 'N/A';
		if (this.defaultlocation.value.length) {
			name = '';
			this.defaultlocation.value.forEach(v => {

				const loc = this.locations.filter(r => {
					return v === r.loccode
				})[0];
				if (loc) {
					name += loc.locationname + ' ';
				}
			});
		}

		return name;
	}

	getLocationNames(): string[] {
		if (!this.defaultlocation.value.length) {return ['N/A'];}

		return this.defaultlocation.value.map(v => {
			const loc = this.locations.find(r => v === r.loccode);
			return loc ? loc.locationname : '';
		}).filter(Boolean); // Filter out undefined or empty locations
	}

	getJournals() {
		const data = {};
		if (this.fetchingJournals) {
			this.fetchingJournals.unsubscribe();
		}
		this.fetchingJournals = this.paymentsService.getClosedJournals(data)
			.pipe(take(1)) // This ensures the observable completes after the first emission
			.subscribe((result: any) => {
				this.journals = result;
			});
	}


	exportPdf() {
		this.exporting = true;
		this.generateHtml().then((html) => {
			const encoded: string = this.globalSearchService.base64encode(html);
			const today = new Date();
			const locations = this.defaultlocation.value && this.defaultlocation.value.length > 0 ?
				this.defaultlocation.value.join(',') :
				'No locations';

			const data = {
				content: encoded,
				filename: this.filename,
				landscape: true,
				title: 'Daily Transactions',
				subtitle: 'Locations: ' + locations + ' ' + this.datefrom.value.toLocaleDateString() + ' - ' + this.dateto.value.toLocaleDateString() + ' created ' + today.toLocaleString()
			};

			this.exporting = true;
			this.printService.pdf(data).subscribe((result: any) => {
				this.exporting = false;
				this.globalSearchService.downloadPdf(result.content, data.filename);
			});
		}).catch((error) => {
			console.error('Error generating HTML:', error);
			this.exporting = false;
		});
	}

	exportXls() {
		this.exporting = true;
		this.generateHtml().then((html) => {
			const encoded: string = this.globalSearchService.base64encode(html);
			const today = new Date();
			const locations = this.defaultlocation.value && this.defaultlocation.value.length > 0 ?
				this.defaultlocation.value.join(',') :
				'No locations';

			const data = {
				content: encoded,
				filename: this.filename,
				title: 'Daily Transactions',
				subtitle: 'Locations: ' + locations + ' ' + this.datefrom.value.toLocaleDateString() + ' - ' + this.dateto.value.toLocaleDateString() + ' created ' + today.toLocaleString()
			};


			this.printService.xls(data).subscribe((result: any) => {
				this.exporting = false;
				this.globalSearchService.downloadXls(result.content, data.filename);
			});
		}).catch((error) => {
			console.error('Error generating HTML:', error);
			this.exporting = false;
		});
	}

	financial(x) {
		if (x == null || isNaN(Number(x))) {
			return '0.00';
		}
		return Number(x).toFixed(2);
	}

	generateHtml(): Promise<string> {
	  const allTransactions = this.payments.transactions.map(pay => ({
			loccode: pay.loccode,
			trandate: pay.trandate,
			order_: pay.order_,
			transno: pay.transno,
			typename: pay.typename,
			payterms: pay.payterms,
			debtorno: pay.debtorno,
			branchcode: pay.branchcode,
			name: pay.name,
			ovamount: this.financial(pay.ovamount),
			ovfreight: this.financial(pay.ovfreight),
			ovdiscount: this.financial(pay.ovdiscount),
			ovgst: this.financial(pay.ovgst),
			ovfee: this.financial(pay.ovfee),
			total: this.financial(pay.total),
			alloc: this.financial(pay.alloc),
			settled: pay.settled,
			reference: pay.reference,
			paytext: pay.paytext,
	  }));

	  const roundedSummary = this.payments.summary.map(p => ({
			...p,
			amount: this.financial(p.amount)
	  }));

	  const roundedTotals = {
			total_sub: this.financial(this.total_sub),
			total_freight: this.financial(this.total_freight),
			total_discount: this.financial(this.total_discount),
			total_tax: this.financial(this.total_tax),
			total_fee: this.financial(this.total_fee),
			total_trans: this.financial(this.total_trans),
			cctotal: this.financial(this.cctotal),
			total_pay: this.financial(this.total_pay),
	  };

	  // Generate the HTML
	  return new Promise((resolve) => {
			let htmlParts: string[] = [];

			htmlParts.push(`
		  <div class="table">
			<div class="bg-white mt-2 rounded">
			  <div id="receipts">
				<h4 class="mt-2 mb-4 noprint">${this.title} ${this.getLocationName()}</h4>
				<table id="rcptTable" name="rcptTable" class="table compact table-sm table-fixed collapsed">
				  <thead>
					<tr>
					  ${this.locations.length > 1 ? '<th class="text-center">Location</th>' : ''}
					  <th class="text-center">Date</th>
					  <th class="text-center">Order#</th>
					  <th class="text-center">Document#</th>
					  <th class="text-center">Type#</th>
					  <th class="text-center">Terms#</th>
					  <th class="text-right">Customer#</th>
					  <th class="text-left">Name</th>
					  <th class="text-right">Amount</th>
					  <th class="text-right">Freight</th>
					  <th class="text-right">Discount</th>
					  <th class="text-right">Tax</th>
					  ${this.config.env.package === 'tires' ? '<th class="text-right">FET</th>' : ''}
					  <th class="text-right"><b>Total</b></th>
					  <th class="text-right"><b>Payment</b></th>
					  <th class="text-center">Settled</th>
					  <th class="text-center">Reference</th>
					  <th class="text-center">Payments</th>
					</tr>
				  </thead>
				  <tbody>`);

			// Loop through transactions
			allTransactions.forEach(pay => {
		  htmlParts.push(`
			<tr>
			  ${this.locations.length > 1 ? `<td class="text-left">${pay.loccode || ''}</td>` : ''}
			  <td class="text-center">${pay.trandate || ''}</td>
			  <td class="text-center">${pay.order_ || ''}</td>
			  <td class="text-center">${pay.transno || ''}</td>
			  <td class="text-center">${pay.typename || ''}</td>
			  <td class="text-center">${pay.payterms || ''}</td>
			  <td class="text-right text-nowrap">
				<a href="/customers/view/${pay.debtorno}">
				  <b>${pay.debtorno || ''}.${pay.branchcode || ''}</b>
				</a>
			  </td>
                          <td class="text-left name-column">${pay.name || ''}</td>
			  <td class="text-right">${pay.ovamount}</td>
			  <td class="text-right">${pay.ovfreight}</td>
			  <td class="text-right">${pay.ovdiscount}</td>
			  <td class="text-right">${pay.ovgst}</td>
			  ${this.config.env.package === 'tires' ? `<td class="text-right">${pay.ovfee}</td>` : ''}
			  <td class="text-right">${pay.total}</td>
			  <td class="text-right ${pay.settled === 'Yes' ? 'text-success' : 'text-danger'}">${pay.alloc}</td>
			  <td class="text-center">${pay.settled || ''}</td>
			  <td class="text-center">${pay.reference || ''}</td>
			  <td class="text-center">${pay.paytext || ''}</td>
			</tr>`);
			});

			// Add totals row
			htmlParts.push(`
		  <tr>
			<td class="text-center"><b>TOTALS</b></td>
			<td class="text-center"></td>
			<td class="text-center"></td>
			<td class="text-center"></td>
			<td class="text-center"></td>
			<td class="text-center"></td>
			<td class="text-center"></td>
			${this.config.env.package === 'tires' ? '<td class="text-center"></td>' : ''}
			<td class="text-center"></td>
			<td class="text-right">${roundedTotals.total_sub}</td>
			<td class="text-right">${roundedTotals.total_freight}</td>
			<td class="text-right">${roundedTotals.total_discount}</td>
			<td class="text-right">${roundedTotals.total_tax}</td>
			${this.config.env.package === 'tires' ? `<td class="text-right">${roundedTotals.total_fee}</td>` : ''}
			<td class="text-right">${roundedTotals.total_trans}</td>
		  </tr>
		</tbody>
		</table>

		<table class="table table-fixed compact table-sm w-50 collapsed">
		  <thead>
			<tr>
			  <th>Type</th>
			  <th class="text-right">Amount</th>
			</tr>
		  </thead>
		  <tbody>`);

			// Loop through payment summary
			roundedSummary.forEach(p => {
		  htmlParts.push(`
			<tr>
			  <td>${p.type || ''}</td>
			  <td class="text-right">${p.amount}</td>
			</tr>`);
			});

			// Add payment totals row
			htmlParts.push(`
			<tr>
			  <th>CC Total</th>
			  <th class="text-right">${roundedTotals.cctotal}</th>
			</tr>
			<tr>
			  <th>Total</th>
			  <th class="text-right">${roundedTotals.total_pay}</th>
			</tr>
		  </tbody>
		</table>
		</div>
		</div>
		</div>`);

			// Join the array of strings into the final HTML and resolve the promise
			resolve(htmlParts.join(''));
			htmlParts = null;
	  });
	}



	updateDayPayMents(event: any) {
		this.today = event;
		this.loadData();
	}

	back(): void {
		this.location.back();
	}

	setPagination(tableData) {
		this.dataSource = new MatTableDataSource < any > (tableData);
		this._changeDetectorRef.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();
	}

	voidPayment(pay: any) {

		this.void_trans = pay;
		this.modalService.open(this.voidDetailsRef, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result) => {

		}, (reason) => {
			this.void_trans = false;
		});

	}

	processVoid() {

		let proceed = true;

		if (this.isPosUser) {
			const empinput = { employee: this.empcode.value }
			this.ordersService.getEmployee(empinput).subscribe((empresult: any) => {
				if (empresult.success) {
					this.emperror = false;
					proceed = true;

					if (proceed) {
						const data = {
							transaction: this.void_trans,
							create_credit: this.create_credit.value,
							voiddate: this.voiddate.value,
							employee: this.empcode.value
						}

						this.voiding = true;
						this.paymentsService.voidInvoice(data).subscribe((result: any) => {
							this.voiding = false;
							if (result.success) {
								this.loadData();
								this.globalSearchService.showNotification(result.message, 'success', 'bottom', 'left')
								this.modalService.dismissAll();
							} else {
								alert(result.message)
							}
						})
					}

				} else {
					this.empcode.setValue('');
					this.emperror = true;
					proceed = false;
				}
			});
		} else {
			//confirm('Void $'+this.financial(this.void_trans.amount)+' on XX'+this.void_trans.cc_data.card_last_four+'?');
			if (proceed) {
				const data = {
					transaction: this.void_trans,
					create_credit: this.create_credit.value,
					voiddate: this.voiddate.value
				}

				this.voiding = true;
				this.paymentsService.voidInvoice(data).subscribe((result: any) => {
					this.voiding = false;
					if (result.success) {
						this.loadData();
						this.globalSearchService.showNotification(result.message, 'success', 'bottom', 'left')
						this.modalService.dismissAll();
					} else {
						alert(result.message)
					}
				})
			}
		}
	}

	// Utility function to format numbers as currency
	formatCurrency(value: number): string {
		return value ? value.toFixed(2) : '0.00';
	}


	openDocument(transaction: any, display: string) {

		switch (transaction.type) {
		case '11':
			this.globalsService.getCreditNote(transaction.id, display).subscribe((result: any) => {
				this.displaydetails = result;
				this.modalService.open(this.detailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((mresult) => {}, (reason) => {});
			})
			break;
		case '10':
			this.globalsService.getInvoice(transaction.id, display).subscribe((result: any) => {
				this.displaydetails = result;
				this.modalService.open(this.detailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((mresult) => {}, (reason) => {});
			})

			break;
		}
	}


}